// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'logData',
  standalone: true
})
export class LogDataPipe implements PipeTransform {

  constructor() { }

  transform(value: any, property?: any): string {
    let data = JSON.parse(value)
    return data[property]


  }
}
